define([
    'jquery',
], function($) {
    'use strict';

    const charLimit = 400;
    const ellipsisText = "...";
    const selectorButton = '.moreless';

    const truncate = function(){
        $(".reviews__blockquote").each(function() {
            let $el = $(this);

            if ($el.hasClass('limited')) {
                return;
            }

            let reviewText = $(this).html();
            if (reviewText.length > charLimit) {
                let c = reviewText.substring(0, charLimit);
                let h = reviewText;
                let html =
                    '<div class="truncate-text" style="display:block">' +
                    c +
                    '<span class="moreellipses">' +
                    ellipsisText +
                    '&nbsp;&nbsp;<a href="" class="moreless more">more</a></span></span></div>' +

                    '<div class="truncate-text" style="display:none">' +
                    reviewText +
                    '<a href="" class="moreless less">Less</a></span></div>';

                $(this).html(html);
                $(this).addClass('limited');
            }
        });

        $(selectorButton).off('click');
        $(selectorButton).on('click', function () {
            let $buttonElement = $(this);
            let cT = $buttonElement.closest(".truncate-text");
            let tX = ".truncate-text";

            if ($buttonElement.hasClass("less")) {
                cT.prev(tX).toggle();
                cT.slideToggle();
            } else {
                cT.toggle();
                cT.next(tX).fadeToggle();
            }

            return false;
        });
    }

    const detach = function() {
        $(selectorButton).off('click');
    };

    return {
        truncate: truncate,
        detachEventHandlers: detach,
    };
});